import { render, staticRenderFns } from "./VideoPitch.vue?vue&type=template&id=e3d476ca&scoped=true"
import script from "./VideoPitch.vue?vue&type=script&lang=js"
export * from "./VideoPitch.vue?vue&type=script&lang=js"
import style0 from "./VideoPitch.vue?vue&type=style&index=0&id=e3d476ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d476ca",
  null
  
)

export default component.exports